/**
 * What a password has to be. Deliberately modest: length is what matters,
 * and the rest is a check against the passwords that show up in every
 * breach list. No mandatory symbols, no rotation, nothing that pushes
 * people toward "Password1!".
 */

export const PASSWORD_MIN = 10;
export const PASSWORD_MAX = 128;

/** The usual suspects; anything containing one of these is out. */
const OBVIOUS = ['password', 'qwerty', '123456', 'letmein', 'iloveyou', 'welcome', 'abc123', 'slate'];

export function passwordProblem(password: string, email = ''): string | null {
  if (password.length < PASSWORD_MIN) return `Use at least ${PASSWORD_MIN} characters.`;
  if (password.length > PASSWORD_MAX) return `Keep it under ${PASSWORD_MAX} characters.`;
  const lower = password.toLowerCase();
  if (OBVIOUS.some((word) => lower.includes(word))) return 'That one is on every guess list. Pick something less obvious.';
  if (/^(.)\1+$/.test(password)) return 'A single repeated character is not a password.';
  const local = email.toLowerCase().split('@')[0];
  if (local.length >= 4 && lower.includes(local)) return 'Leave your email out of it.';
  return null;
}
